// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"519":"6579fb85","797":"7303fd9e","798":"3d185b66","918":"b99bc811"}[chunkId] + ".css";
};